














import { Command } from "@/lib/Command";
import { Component, Vue } from "vue-property-decorator";
import CommandForm from '@/components/Forms/CommandForm.vue'

@Component({
  components: {
    CommandForm
  },
})
export default class CommandTreeComponent extends Vue {
  get Commands(): Array<Command> {
    return this.$store.state.command.commands;
  }

  public RemoveCommand(commandName: string): void {
    this.$store.commit("removeCommand", commandName);
  }
}
